/** @format */

import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import CardWrap from "../../Common/CardWrap";
import { useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";
import iconcontentcalendar from "../../../Images/Icons/iconcontentcalendar.png";
import Select from "react-select";
import DatePicker, { registerLocale } from "react-datepicker";
import { GlobalContext } from "../../../Contexts/GlobalContextProvider";
import { globalServices } from "../../../Services/global.service";
import { returnReceiptService } from "../../../Services/AccountingServices/returnReceipt.service";
import { storeService } from "../../../Services/store.service";
import ResultModal from "../../Common/ResultModal";
import AddProductModal from "../../Common/AddProductModal";
import hr from "date-fns/locale/hr";
import en from "date-fns/locale/en-US";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import cellEditFactory from "react-bootstrap-table2-editor";
import AsyncSelect from "react-select/async";
import ProductsFilterModal from "../../Common/ProductsFilterModal";
import { AuthContext } from "../../../Contexts/AuthContext";
import { roles } from "../../../Config/Roles";
registerLocale("hr", hr);
registerLocale("en", en);

const DocumentCreate = () => {
  const { userId, useAccounting, roleId } = useContext(AuthContext);
  const { selectedLanguageId, isMobile } = useContext(GlobalContext);
  const { t: translator } = useTranslation();
  const history = useHistory();
  const { register, handleSubmit, errors, control, formState, setValue } =
    useForm({
      mode: "onChange",
      reValidateMode: "onChange",
    });

  const [showFilterModal, setShowFilterModal] = useState(false);
  const [stores, setStores] = useState([]);
  const [partners, setPartners] = useState([]);
  const [products, setProducts] = useState([]);
  const [loadModal, setLoadModal] = useState(false);
  const [values, setValues] = useState({
    storeId: 0,
    tenantId: 0,
    priceListId: 0,
  });
  const [showProductModal, setShowProductModal] = useState(false);
  const [modalValidationMsg, setModalValidationMsg] = useState("");

  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
  });

  const addFilterProducts = (filterProducts) => {
    let newArr = [...products];

    //svi koji su bili izbrisani u state isActive false
    let oldDeleted = newArr.filter((ar) =>
      products.find(
        (rm) => rm.productGuid === ar.productGuid && ar.isActive === false,
      ),
    );

    //vraćam ih na isActive true
    oldDeleted.forEach((el) => (el.isActive = true));

    //ukloniti treci niz iz statea
    newArr = newArr.filter(
      (ar) => !oldDeleted.find((rm) => rm.productGuid === ar.productGuid),
    );

    //vraćamo stare kao isActive true
    newArr = newArr.concat(oldDeleted);

    let addedProducts = filterProducts.filter(
      (item) => !newArr.find((rm) => rm.productGuid === item.productGuid),
    );

    let newProducts = addedProducts.map((prod) => ({
      productGuid: prod.productGuid,
      productName: prod.productName,
      price: prod.price,
      quantity: 0,
    }));

    newArr = newArr.concat(newProducts);
    setProducts(newArr);
  };

  const addNewProduct = (productGuid, productName, price) => {
    setProducts([
      ...products,
      { productGuid, productName, price, quantity: 0 },
    ]);
  };

  const onSubmit = (data) => {
    let formatedDate = new Date(
      new Date(data.date).getTime() + 8 * 60 * 60 * 1000,
    );

    returnReceiptService
      .documentCreate(
        formatedDate,
        data.storeId.id,
        data.partnerGuid.id,
        data.note,
        products,
      )
      .then((res) => {
        if (res.data.success) {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-CreateSuccess-Title",
            text: "InitialState-ResultModal-CreateSuccess-Text",
            show: true,
            btnClass: "btn btn-primary",
            success: true,
          });
        } else {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-CreateError-Title",
            text: translator(res.data.message),
            show: true,
            btnClass: "btn btn-primary",
            success: false,
          });
        }
      })
      .catch((err) => console.log(err));
  };

  const handleClose = () => {
    setModal({ ...modal, show: false });
    if (modal.success) {
      history.push("/returnReceipt");
    }
  };

  const handleCancel = () => {
    history.goBack();
  };

  useEffect(() => {
    if (!useAccounting) history.push("/error-page/401");
  }, []);

  const promiseOptions = (inputValue) => {
    return globalServices
      .getTenantsRobno(
        Number(localStorage.getItem("tenantId")) > 0 ? userId : null,
        inputValue,
      )
      .then((res) => {
        var result = res.data.map((e) => ({
          id: e.id,
          label: e.name,
          value: e.id,
        }));
        if (Number(roleId) === roles.owner && result.length === 1) {
          const tenantId =
            Number(localStorage.getItem("tenantId")) > 0
              ? Number(localStorage.getItem("tenantId"))
              : 0;
          const tenant = result.find((x) => x.id === tenantId) || null;
          setValue("tenantId", tenant);
          handleOnChangeTenantId(tenant ? [tenant] : null);
        }
        result.unshift({
          id: 0,
          label: translator("SelectTenant-Choose"),
          value: 0,
        });
        return result;
      })
      .catch((err) => err);
  };

  function actionFormatter(cell, row) {
    return (
      <div className="action">
        <span className="icon icon-cancel" style={{ color: "#c00" }}></span>
      </div>
    );
  }

  const options = {
    sizePerPage: 10,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  };

  const { SearchBar } = Search;
  function currencyFormatter(cell) {
    return new Intl.NumberFormat("hr", {
      style: "currency",
      currency: "EUR",
    }).format(Number(cell));
  }
  const columns = [
    {
      dataField: "productGuid",
      text: "",
      headerStyle: (colum, colIndex) => {
        return { width: "50px", textAlign: "center" };
      },
      formatter: actionFormatter,
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          setProducts(
            products.filter((item) => item.productGuid !== row.productGuid),
          );
        },
      },
    },
    {
      dataField: "productName",
      text: translator("InitialState-Product"),
    },
    {
      dataField: "price",
      text: translator("InitialState-Price"),
      formatter: currencyFormatter,
      editable: false,
      hidden: Boolean(isMobile),
    },
    {
      dataField: "quantity",
      text: `${translator("InitialState-Quantity")}*`,
      validator: (newValue, row, column) => {
        if (isNaN(newValue) || newValue == "") {
          return {
            valid: false,
            message: translator("QuantityNumberMsg"),
          };
        }
        if (newValue < 0) {
          return {
            valid: false,
            message: translator("QuantityNotNegative"),
          };
        }

        if (newValue >= 100000) {
          return {
            valid: false,
            message: translator("QuantityMaxThousand"),
          };
        }

        return true;
      },
    },
  ];

  const handleOnChangeTenantId = (event) => {
    if (!event) return;
    setValue("storeId", null, {
      shouldValidate: true,
    });
    setValue("partnerGuid", null, {
      shouldValidate: true,
    });
    globalServices
      .getStoresByTenantId(event[0].id)
      .then((res) => {
        setStores(res.data);
        setProducts([]);
      })
      .catch((err) => console.log(err));
    return event[0];
  };

  return (
    <>
      <CardWrap subtitle={translator("InitialState-DocumentCreate")}>
        <form onSubmit={handleSubmit(onSubmit)} className="row">
          <div className="col-lg-4">
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">
                {translator("InitialState-IndexData")}
              </legend>
              <div className="form-group">
                <div className="form-group">
                  <label>{translator("InitialState-Date")}</label>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text" id="basic-addon1">
                        <img src={iconcontentcalendar} alt="calendar" />
                      </span>
                    </div>
                    <Controller
                      as={DatePicker}
                      control={control}
                      autoComplete="off"
                      className="form-control"
                      dateFormat="dd.MM.yyyy"
                      name="date"
                      showYearDropdown={true}
                      rules={{ required: true }}
                      locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                      valueName="selected"
                      defaultValue={new Date()}
                      onChange={([selected]) => selected}
                    />
                    {errors.date && errors.date.type === "required" && (
                      <p className="col-md-10 pl-0 text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                  </div>
                </div>
                <div className="form-group">
                  <label>{translator("EditPOS-Tenant")}</label>{" "}
                  <Controller
                    as={AsyncSelect}
                    control={control}
                    name="tenantId"
                    onChange={handleOnChangeTenantId}
                    placeholder={translator("Select-Tenant")}
                    defaultOptions={true}
                    loadOptions={promiseOptions}
                    rules={{
                      validate: function (value) {
                        if (!value) return false;
                        return value.value === 0 ? false : true;
                      },
                    }}
                  />
                  {errors.tenantId && errors.tenantId.type === "validate" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                </div>
                <div className="form-group">
                  <label>{translator("InitialState-Store")}</label>
                  <Controller
                    as={Select}
                    options={
                      stores &&
                      stores.map((p) => ({
                        id: p.id,
                        label: p.name,
                        value: p.id,
                      }))
                    }
                    name="storeId"
                    placeholder={translator("Select-Store")}
                    rules={{
                      validate: function (value) {
                        if (!value) return false;
                        return value.value === null ? false : true;
                      },
                    }}
                    control={control}
                    onChange={function (event) {
                      setModalValidationMsg("");
                      setValue("partnerGuid", null, {
                        shouldValidate: true,
                      });
                      setProducts([]);

                      storeService
                        .getById(event[0].id)
                        .then((res) => {
                          setValues({
                            storeId: event[0].id,
                            tenantId: res.data.tenantId,
                            priceListId: res.data.priceListId,
                          });
                          globalServices
                            .getPartnersByTenantId(res.data.tenantId)
                            .then((response) => setPartners(response.data))
                            .catch((err) => console.log(err));
                          setLoadModal(true);
                        })
                        .catch((err) => console.log(err));

                      return event[0];
                    }}
                  />
                  {errors.storeId && errors.storeId.type === "validate" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                </div>
                <div className="form-group">
                  <label>{translator("Partner")}</label>
                  <Controller
                    as={Select}
                    options={
                      partners &&
                      partners.map((p) => ({
                        id: p.id,
                        label: p.name,
                        value: p.id,
                      }))
                    }
                    name="partnerGuid"
                    placeholder={translator("Select-Partner")}
                    rules={{
                      validate: function (value) {
                        if (!value) return false;
                        return value.value === null ? false : true;
                      },
                    }}
                    control={control}
                    onChange={function (event) {
                      return event[0];
                    }}
                  />
                  {errors.partnerGuid &&
                    errors.partnerGuid.type === "validate" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                </div>
                <div className="form-group">
                  <label>{translator("InitialState-Note")}</label>
                  <textarea
                    name="note"
                    ref={register({ maxLength: 250 })}
                    className="form-control"
                    rows={4}
                    id="textArea"
                  ></textarea>
                  {errors.note && errors.note.type === "maxLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength250")}
                    </p>
                  )}
                </div>
              </div>
            </fieldset>
          </div>
          <div className="col-lg-8">
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">
                {translator("InitialState-Items")}
              </legend>

              <div className="form-group">
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    if (document.getElementsByName("storeId")[0].value === "") {
                      setModalValidationMsg("ValidationMsg-SelectStore");
                    } else setShowFilterModal(true);
                  }}
                >
                  <span className="icon icon-filter"></span>{" "}
                  {translator("Filter")}
                </button>
                &nbsp;
                {/* <button
                  className="btn btn-primary"
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    if (document.getElementsByName("storeId")[0].value === "") {
                      setModalValidationMsg("ValidationMsg-SelectStore");
                    } else setShowProductModal(true);
                  }}
                >
                  {translator("InitialState-AddProduct")}
                </button> */}
                <span className="text-danger ml-2">
                  {translator(modalValidationMsg)}
                </span>
              </div>
              <ToolkitProvider
                keyField="productGuid"
                data={products}
                columns={columns}
                search
              >
                {(props) => (
                  <>
                    <div className="form-group">
                      <SearchBar
                        {...props.searchProps}
                        placeholder={translator("Search")}
                        className="col-md-12"
                      />
                    </div>

                    <hr />
                    <BootstrapTable
                      {...props.baseProps}
                      noDataIndication={translator("No-Data")}
                      pagination={paginationFactory(options)}
                      cellEdit={cellEditFactory({
                        mode: "click",
                        blurToSave: true,
                      })}
                    />
                    <p>
                      <span className="editableColumns">*</span>
                      {translator("EditableTableColumns")}
                    </p>
                  </>
                )}
              </ToolkitProvider>
            </fieldset>
          </div>
          <div
            className="container-fluid mt-4"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <button
              className="btn btn-outline-secondary"
              onClick={handleCancel}
            >
              {translator("POS-New_EditPOS-Close")}
            </button>
            &nbsp;
            <button
              className="btn btn-primary"
              disabled={!formState.dirty}
              type="submit"
            >
              {translator("POS-New_EditPOS-Save")}
            </button>
          </div>
        </form>
      </CardWrap>
      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
      {loadModal && (
        <ProductsFilterModal
          show={showFilterModal}
          storeId={values.storeId}
          prodList={products}
          documentOption={2}
          handleHide={() => setShowFilterModal(false)}
          confirmAdd={addFilterProducts}
        />
      )}
      {loadModal && (
        <AddProductModal
          show={showProductModal}
          tenantId={values.tenantId}
          priceListId={values.priceListId}
          addNewProduct={addNewProduct}
          handleHide={() => setShowProductModal(false)}
        />
      )}
    </>
  );
};

export default DocumentCreate;
